export class RegexHelper {
  static like(a: string, b: string) {
    const normA = a
      .normalize('NFD')
      .replace(/\p{Diacritic}/gu, '')
      .toLowerCase()
    const normB = b
      .normalize('NFD')
      .replace(/\p{Diacritic}/gu, '')
      .toLowerCase()
    return normA.includes(normB)
  }

  static validateEmail(email: string): boolean {
    const re = /\S+@\S+\.\S+/
    return re.test(email)
  }

  static validatePassword(password: string) {
    const passwordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/
    return passwordRegex.test(password)
  }

  static validateUUID(id: string) {
    const re =
      /[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}/
    return re.test(id)
  }
}
